import React from "react";
import "./popups.css";
import CombatDemo from "../../../assets/videos/demo_combat.gif";

const ActionPopup = () => {
  return (
    <div className="popup">
      <h1 className="popup__title">Project A</h1>
      <div className="action__content">
        <div className="action__desc_container">
          <p className="popup__desc">
            This is a demo of 3D action/combat mechanics in Unity where your
            weapons color the enemies and let you consume them! The aim of this
            project was to learn more about designing code architecture for
            games along with scripting gameplay mechanics.
          </p>
        </div>
        <div className="action__demo_container">
          <img
            className="action__demo"
            src={CombatDemo}
            alt="combat game demo"
          />
        </div>
      </div>
    </div>
  );
};

export default ActionPopup;
